/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Faq_Same_Email_AInputs */



/**
* | output |
* | --- |
* | "In oneAI an account belongs to one organisation. If you use the same email address for your own oneAI workspace and for a customer's organisation, those are ..." |
*
* @param {Partner_Faq_Same_Email_AInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_faq_same_email_a = /** @type {((inputs?: Partner_Faq_Same_Email_AInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Faq_Same_Email_AInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("In oneAI gehört ein Konto zu einer Organisation. Verwenden Sie dieselbe E-Mail-Adresse für Ihren eigenen oneAI-Arbeitsbereich und für die Organisation eines Kunden, sind das getrennte Konten mit jeweils eigener Anmeldung; bei der Anmeldung in oneAI kann Ihr Gerät mehrere Passkeys anbieten — wählen Sie den der gewünschten Organisation. Dieses Portal hat ein eigenes Konto und eigene Passkeys, getrennt von oneAI. Wir empfehlen eine eigene E-Mail-Adresse pro Organisation.")
	return /** @type {LocalizedString} */ ("In oneAI an account belongs to one organisation. If you use the same email address for your own oneAI workspace and for a customer's organisation, those are separate accounts, each with its own sign-in; when you sign in to oneAI, your device may offer several passkeys — choose the one for the organisation you want. This portal has its own account and passkeys, separate from oneAI. We recommend a different email address for each organisation.")
});